//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TestTeacherInputItem } from './TestTeacherInputItem';
import { TestBillingProfileInputItem } from './TestBillingProfileInputItem';
import { TestEventLocationInputItem } from './TestEventLocationInputItem';
import { TestEventCategoryInputItem } from './TestEventCategoryInputItem';
import { TestFamilyInputItem } from './TestFamilyInputItem';
import { TestStudentInputItem } from './TestStudentInputItem';
import { TestParentInputItem } from './TestParentInputItem';
import { TestMileageInputItem } from './TestMileageInputItem';
import { TestLendingLibraryInputItem } from './TestLendingLibraryInputItem';
import { TestRepertoireInputItem } from './TestRepertoireInputItem';
import { TestPerformanceInputItem } from './TestPerformanceInputItem';
import { TestNewsInputItem } from './TestNewsInputItem';
import { TestTransactionInputItem } from './TestTransactionInputItem';
import { TestInvoiceInputItem } from './TestInvoiceInputItem';
import { TestCalendarEventInputItem } from './TestCalendarEventInputItem';

export class TestSchoolInputItem extends ItemBase {
    EmailAddress: string | null = null;
    FirstName: string | null = null;
    LastName: string | null = null;
    IsMultiTeacher: boolean = false;
    Password: string | null = null;
    SchoolName: string | null = null;
    Country: string | null = null;
    TestTeacherInputItems: TestTeacherInputItem[] = [];
    TestBillingProfileInputItems: TestBillingProfileInputItem[] = [];
    TestEventLocationInputItems: TestEventLocationInputItem[] = [];
    TestEventCategoryInputItems: TestEventCategoryInputItem[] = [];
    TestFamilyInputItems: TestFamilyInputItem[] = [];
    TestStudentInputItems: TestStudentInputItem[] = [];
    TestParentInputItems: TestParentInputItem[] = [];
    TestMileageInputItems: TestMileageInputItem[] = [];
    TestLendingLibraryInputItems: TestLendingLibraryInputItem[] = [];
    TestRepertoireInputItems: TestRepertoireInputItem[] = [];
    TestPerformanceInputItems: TestPerformanceInputItem[] = [];
    TestNewsInputItems: TestNewsInputItem[] = [];
    TestTransactionInputItems: TestTransactionInputItem[] = [];
    TestInvoiceInputItems: TestInvoiceInputItem[] = [];
    TestCalendarEventInputItems: TestCalendarEventInputItem[] = [];

    constructor(initializer?: Partial<TestSchoolInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TestSchoolInputItem";
}
